// extracted by mini-css-extract-plugin
export default {"root":"SourceView_root__PjiG1","header":"SourceView_header__y1O67","body":"SourceView_body__jgrQa"};